import React, {createContext, PropsWithChildren, useContext, useEffect, useState} from 'react';
import {BillingDetails, Organization} from "myfitworld-model";
import {useUserProvider} from "./UserProvider";
import {firestore} from "../firebase";
import organizationsApi, { OrganizationContextState, subscribeToOrganization } from "../api/organizationsApi";
import {getOrganizationBillingDetails} from "../api/billingDetailsApi";
import { useMfwThemeProvider } from 'myfitworld-utils';

const OrganizationContext = createContext<[OrganizationContextState, (organization: Organization) => void]>([{}, (_) => {
}])

const updateCurrentOrganization = (userId: string | undefined, organization: Organization) => {
  if (!userId) return;
  firestore.collection('users').doc(userId).set({
    currentOrganization: organization.id
  }, {merge: true})
    .catch(err => console.error('Failed to update users currentOrganization', err))
};

export const OrganizationProvider = ({children}: PropsWithChildren<any>) => {
  const [organizationContextState, setOrganizationContextState] = useState<OrganizationContextState>({});
  const {user, organizationOverride} = useUserProvider();
  const {updateTheme} = useMfwThemeProvider();

  const selectOrganization = (organization: Organization) => {
    updateCurrentOrganization(user?.id, organization);
    organization?.id && getOrganizationBillingDetails(organization?.id).then(
      (res) => {
        setOrganizationContextState(prevState => ({
          ...prevState,
          selectedOrganization: {
            ...organization,
            quantity: (res as unknown as BillingDetails)?.stripe?.quantity || 0
          }
        }));
      }
    );
  }

  useEffect(() => {
    if (!user || !user.id || !user.organizations) return;

    const unsubscribe = subscribeToOrganization(user, updateCurrentOrganization, updateTheme, setOrganizationContextState);
    return () => unsubscribe();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])


  useEffect(() => {
    if (organizationOverride) {
      organizationsApi.get(organizationOverride)
        .then(resultOrganization => {
          resultOrganization?.id && getOrganizationBillingDetails(resultOrganization?.id).then(
            (res) => {
              setOrganizationContextState(prevState => ({
                ...prevState,
                selectedOrganization: {
                  ...resultOrganization,
                  quantity: (res as unknown as BillingDetails)?.stripe?.quantity || 0
                }
              }));
            }
          );
        })
        .catch(err => console.error('Org not found ', organizationOverride, err))
    }
  }, [organizationOverride])

  return <OrganizationContext.Provider
    value={[organizationContextState, selectOrganization]}>{children}</OrganizationContext.Provider>
}

export const useOrganizationProvider = () => {
  const context = useContext(OrganizationContext);

  if (context === undefined) {
    throw new Error(
      'useOrganizationProvider must be used within an OrganizationProvider'
    );
  }
  return context;
};
